import { extendObservable, action } from 'mobx';

import { get, jsonParser } from '../utils/Client';

import AuthenticationStore from './AuthenticationStore';

class SelecaoStore {
  constructor() {
    extendObservable(this, {
      rodadaSelecionada: null,

      coligacoes: [],

      candidatos: [],

      candidato: null,

      intencoes: [],

      intencoesMunicipio: [],

      load: action(() => {
        let pesquisa = AuthenticationStore.me.pesquisa;
        if (localStorage.ultimaRodada) {
          this.rodadaSelecionada = pesquisa.rodadas.filter(
            r => r.numero === Number(localStorage.ultimaRodada)
          )[0];
        } else if (pesquisa.rodadas.length > 0) {
          let isAdmin = AuthenticationStore.hasRole('ADMIN');
          let rodadas = pesquisa.rodadas.filter(r => r.aprovada || isAdmin);
          let lastIndex = rodadas.length - 1;
          this.rodadaSelecionada = rodadas[lastIndex];
          localStorage.ultimaRodada = this.rodadaSelecionada.numero;
        }
        if (!this.rodadaSelecionada) {
          this.rodadaSelecionada = { id: -1, participacoes: [] };
        }
      }),

      get participacao() {
        let participacao = this.rodadaSelecionada.participacoes.filter(
          p => p.cargo.id === AuthenticationStore.me.cargo.id
        )[0];
        return participacao
          ? participacao
          : {
              candidatos: 0,
              indecisos: 0,
              brancos: 0,
              nulos: 0,
              naoVotara: 0,
              coeficiente: 0,
            };
      },

      selecionarRodada: action(numero => {
        this.rodadaSelecionada = AuthenticationStore.me.pesquisa.rodadas.filter(
          r => r.numero === numero
        )[0];
        localStorage.ultimaRodada = this.rodadaSelecionada.numero;
      }),

      loadCandidatos: action((tipo = null) =>
        get(
          `/rodadas/${this.rodadaSelecionada.id}/candidatos` +
            (tipo ? '/' + tipo : '')
        )
          .then(jsonParser)
          .then(data => (this.candidatos = data))
      ),

      loadColigacoes: action(() =>
        get(`/rodadas/${this.rodadaSelecionada.id}/coligacoes`)
          .then(jsonParser)
          .then(data => (this.coligacoes = data))
      ),

      selecionarCandidatos: action(coligacao =>
        get(`/rodadas/${this.rodadaSelecionada.id}/coligacoes/${coligacao.id}`)
          .then(jsonParser)
          .then(data => (this.candidatos = data))
      ),

      selecionarCandidato: action((coligacao, posicao) =>
        get(
          `/rodadas/${this.rodadaSelecionada.id}` +
            `/coligacoes/${coligacao.id}/${posicao}`
        )
          .then(jsonParser)
          .then(data => (this.candidato = data))
      ),
    });
  }
}

export default new SelecaoStore();



// WEBPACK FOOTER //
// ./src/stores/SelecaoStore.js